import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {
  MatTableDataSource
} from "@angular/material/table";
import {ExtracurricularRuleService} from "../../../shared/services/extracurricular-rule.service";
import {ExtracurricularRule} from "../../../shared/models/extracurricular-rule.model";
import {ToastrService} from "ngx-toastr";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {AcademicYear} from "../../../shared/models/academic-year.model";
import {AcademicCalendarService} from "../../../shared/services/academic-calendar.service";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {Subscription} from "rxjs";
import {SchoolProgramService} from "../../../shared/services/school-program.service";
import {RuleModel} from "../../../shared/models/rule.model";
import {PathwayMappingService} from "../../../shared/services/pathway-mapping.service";
import Swal from "sweetalert2";
import { TranslateService } from 'src/shared/services/translate.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { AuthService } from 'src/shared/services/auth.service';
import { RulesService } from 'src/shared/services/rules.service';

@Component({
  selector: 'app-rules',
  styleUrls: ['./rules.component.scss'],
  templateUrl: './rules.component.html',
})
export class RulesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('viewRule', {static: true}) public modalViewRule: NgbModalRef;
  @ViewChild('addRule', {static: true}) public modalAddRule: NgbModalRef;
  @ViewChild('editRule', {static: true}) public modalEditRule: NgbModalRef;
  heading = "Rules";
  loading = false;
  paramForm: FormGroup;
  currentPage = 1;
  dataRules: any = [];
  total = 0;
  hasData = false;
  detailData: any = null;
  yearLevelDataList : any = [];
  columnsToDisplay = ['school_program_name','year_level','valid_from', 'selection'];
  newRuleForm: FormGroup;
  editRuleForm: FormGroup;
  checkApiRun: Subscription;
  disableButtonAdd = true;
  disableButtonEdit = true;
  selectedYearLevel: any = [];
  yearLevelSelect= false;
  currentAcademic: any = null;
  constructor(private schoolProgramService: SchoolProgramService,
              private toastr: ToastrService,
              private academicService: AcademicCalendarService,
              private modalService: NgbModal,
              private pmService: PathwayMappingService,
              private translate: TranslateService,
              private rpSer: ResponseService,
              public auth: AuthService,
              private ruleService: RulesService
            ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    if (this.auth.permissions['SCHOOL_PROGRAM_RULE_EDIT'] || this.auth.permissions['SCHOOL_PROGRAM_RULE_DELETE']) {
      this.columnsToDisplay.push('action');
    }
    this.translate.load('extracurricular', 'rules');
    this.initForm();
    this.trackFormChanges();
    this.getCurrentAcademicYear();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_level_id': new FormControl(null),
    });

    this.newRuleForm = new FormGroup({
      'year_level_id': new FormControl([]),
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'valid_from': new FormControl(null),
    })

    this.editRuleForm = new FormGroup({
      'rule_id': new FormControl(null),
      'year_level': new FormControl([]),
      'school_program_id': new FormControl(null),
      'valid_from': new FormControl(null),
    })

  }

  ngAfterViewInit() {
    this.dataRules.paginator = this.paginator;
  }
  trackFormChanges() {
    this.newRuleForm.valueChanges.subscribe(() => {
      this.disableButtonAdd =
          !this.newRuleForm.get('school_program_id')?.value ||
          !this.newRuleForm.get('school_location_id')?.value ||
          !this.newRuleForm.get('valid_from')?.value;
    });

  }

  onChangeSchoolLevel(item: any, action = 'list') {

    if (action == 'list') {
      this.paramForm.controls['school_location_id'].markAsTouched();
      this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

      this.paramForm.controls['school_level_id'].markAsTouched();
      this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

      this.paramForm.controls['year_level_id'].setValue(null);

      if (item && this.paramForm.controls['school_level_id'].value) {
        this.getRuleData();
      }
    } else if (action =='add') {
      this.newRuleForm.controls['school_location_id'].markAsTouched();
      this.newRuleForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

      this.newRuleForm.controls['school_level_id'].markAsTouched();
      this.newRuleForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

      this.yearLevelDataList = [];
      this.newRuleForm.controls['year_level_id'].setValue(null);
    }

  }
  onChangeYearLevel(item: any, action = 'list') {
    if (!item) {
      return;
    }
    if(action =='add') {
      this.newRuleForm.controls['year_level_id'].markAsTouched();
      const data = item.map((i: { year_level_id: any; }) => i.year_level_id);
      this.newRuleForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
    } else if(action == 'edit') {
      this.editRuleForm.controls['year_level_id'].markAsTouched();
      const data = item.map((i: { year_level_id: any; }) => i.year_level_id);
      this.editRuleForm.controls['year_level_id'].setValue(data.length > 0 ? data : null);
    }

  }
  onChangeSchoolProgram(item: any, action = 'list') {

    if (action == 'list') {
      this.paramForm.controls['school_program_id'].markAsTouched();
      this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);
      this.getRuleData();
    } else if (action =='add') {
      this.newRuleForm.controls['school_program_id'].markAsTouched();
      this.newRuleForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);
      this.yearLevelDataList = [];
      this.getYearLevel();
    }
  }
  getYearLevel(){
    this.pmService.yearLevelNoAcademic({
      school_location_id: this.newRuleForm.get('school_location_id')?.value,
      school_level_id: this.newRuleForm.get('school_level_id')?.value,
    })
        .subscribe((response: any) => {
          this.yearLevelDataList = [...new Map(response['data'].map((item: { year_level_id: any; }) => [item.year_level_id, item])).values()];

          this.yearLevelDataList = this.yearLevelDataList.map((year: any) => ({
            year_level_id: year.year_level_id,
            year_level_name: year.description,
            minimum_selection: null,
            maximum_selection: null
          }));
        }, (error: any) => {
          this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        });
  }
  onChangePage(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;

    this.getRuleData();
  }
  getCurrentAcademicYear() {
    this.academicService.getAcademicYearsOnlyCurrent()
        .subscribe((response: AcademicYear) => {
          // @ts-ignore
          if (response['error'] === 0) {
            // @ts-ignore
            this.currentAcademic = new AcademicYear().deserialize(response['result']['data']);
          } else {
            // @ts-ignore
            this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
          }
        }, (error: any) => {
          this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
        });
  }
  getRuleData () {
    this.loading = true;
    if (this.checkApiRun) {
      this.checkApiRun.unsubscribe();
    }
    this.checkApiRun = this.ruleService.getRuleList(this.paramForm.value)
        .subscribe(
            (response: RuleModel[]) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                this.dataRules = response['data'];
                // @ts-ignore
                this.total = this.dataRules ? this.dataRules.length : 0;
                this.hasData = this.total > 0;
                this.loading = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
              }
            },
            error => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
              this.loading = false;
            });
  }

  getRuleDetail(id: number) {

    this.detailData = null;
    this.selectedYearLevel = [];
    this.ruleService.getRuleDetail(id)
        .subscribe(
            (response: any) => {
              // @ts-ignore
              if (response['status']) {
                // @ts-ignore
                const data =  response['data'];
                this.detailData = data;
                this.editRuleForm.patchValue({
                  rule_id: data.rule_id,
                  school_program_id: data.school_program_id,
                  valid_from: data.valid_from ? data.valid_from.split('T')[0] : '',
                  year_level: data.year_level.map((level: any) => ({
                    ...level,
                    minimum_selection: data.minimum_selection,
                    maximum_selection: data.maximum_selection
                  }))
                });
                this.editRuleForm.controls['valid_from'].disable();
                this.selectedYearLevel.push(...data.year_level.map((level: any) => level.year_level_id));
                this.disableButtonEdit = false;
              } else {
                // @ts-ignore
                this.toastr.error('[' + this.heading + '] ' + response['message'], 'Invalid Response');
              }
            },
            error => {
              this.toastr.error('[' + this.heading + '] Cannot access server endpoint!', 'Connection Error');
            });
  }
  onOpenModelAddRule () {
    this.newRuleForm.reset({
      year_level_id: [],
      academic_year: null,
      school_location_id: null,
      school_program_id: null
    });
    this.modalService.open(this.modalAddRule, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
  }
  onOpenModelEditRule (data: any) {
    this.modalService.open(this.modalEditRule, {
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      size: 'lg'
    }).result.then((result: any) => {

    }, (reason: any) => {

    });
    this.editRuleForm.reset();
    this.getRuleDetail(data.rule_id);


  }
  onAddRule() {
    for (const yl of this.yearLevelDataList) {
      if (yl.minimum_selection > yl.maximum_selection) {
        this.rpSer.showAddError('Minimum selection must be less than or equal to maximum selection.');
        return;
      }
    }
    const data = {
      ...this.newRuleForm.value,
      year_level: this.yearLevelDataList
    }
    this.ruleService.saveRule(data).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showAddSuccess('Rule has been added successfully.');
            this.modalService.dismissAll();
            this.getRuleData();
          } else {
            this.rpSer.showAddError('Failed to add rule. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showAddError();
        }
    );
  }
  validateSelection(year: any, type: 'min' | 'max', event: any) {
    const inputElement = event.target as HTMLInputElement;
    const value = Number(inputElement.value);
    if (type === 'min') {
      year.minimum_selection = Math.max(0, value);

      if (year.maximum_selection !== undefined && year.minimum_selection > year.maximum_selection) {
        year.maximum_selection = year.minimum_selection;
      }
    } else if (type === 'max') {
      year.maximum_selection = Math.max(0, value);

      if (year.minimum_selection !== undefined && year.maximum_selection < year.minimum_selection) {
        year.minimum_selection = year.maximum_selection;
      }
    }
  }
  onEditRule() {
   const yearLevelDataList = this.editRuleForm.get('year_level')?.value.filter((item:any) =>
        this.selectedYearLevel.includes(item.year_level_id)
    );
    this.editRuleForm.controls['year_level'].setValue(yearLevelDataList);
    this.editRuleForm.controls['valid_from'].enable();
    this.ruleService.updateRule(this.editRuleForm.value,).subscribe(
        (response: any) => {
          if (response['status']) {
            this.rpSer.showEditSuccess('Rule has been updated successfully.');
            this.modalService.dismissAll();
            this.getRuleData();
          } else {
            this.rpSer.showEditFailed('Failed to update rule. Please try again.');
          }
        },
        (error: any) => {
          this.rpSer.showEditFailed();
        }
    );
  }

  onDelete(data: any){
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this rule?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.ruleService.deleteRule(data.rule_id).subscribe(
            async (response: any) => {
              if (response['status']) {;
                this.rpSer.showDeleteSuccess('Rule has been deleted.');
                this.getRuleData();
              } else {
                this.rpSer.showDeleteFailed('Failed to delete rule. Please try again.');
              }
            },
            (error: any) => {
              this.rpSer.showDeleteFailed();
            }
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    });
  }

  isChecked(id: number) {
    // @ts-ignore
    const index = this.selectedYearLevel.indexOf(id);
    return index !== -1;
  }
  onChecked(id: number) {
    // @ts-ignore
    const index = this.selectedYearLevel.indexOf(id);

    if (index === -1) {
      this.yearLevelSelect = true;
      // @ts-ignore
      this.selectedYearLevel.push(id);
    } else {
      this.selectedYearLevel.splice(index, 1);
    }

    if (this.selectedYearLevel.length === 0) {
      this.yearLevelSelect = false;
    }
  }
}
